import { Link } from "react-router-dom";
import YogaNavBar from "./YogaNavBar";

export default function YogaSchedule () {
    return (
        <>
        <div>
            <YogaNavBar/>
            <div className="relative">
            <img
                src={require("./images/arizona_yoga.jpeg")}
                alt="Yoga in Arizona"
                className="w-full h-[400px] object-cover"
            />

             <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-2/3 w-full text-center text-white text-2xl md:text-4xl">
                Schedule
            </div>
        </div>
        <div className="text-center mt-10">
            <h1 className="text-xl">SUNDAY</h1>
            <Link
            to="https://mindbodylove.com/schedule"
            className="flex justify-center items-center space-x-2"
            >
            <p className="text-lg">8AM</p>
            <p className="underline">Vinyasa Yoga (60 Minutes)</p>
            </Link>
            <Link
            to="https://sinainfluxyoga.setmore.com/classes/ea9e0268-6e6c-402a-93b4-964b6324c365"
            className="flex justify-center items-center space-x-2 mt-2"
            >
            <p className="text-lg">10AM</p>
            <p className="underline">Nature Flow (60 Minutes)</p>
            </Link>

            </div>
            <div className="text-center mt-10">
            <h1 className="text-xl">TUESDAY</h1>
            <Link
            to="https://mindbodylove.com/schedule"
            className="flex justify-center items-center space-x-2 mt-2"
            >
            <p className="text-lg">6:30AM</p>
            <p className="underline">Vinyasa Yoga (45 Minutes)</p>
            </Link>


            </div>
            <div className="text-center mt-10">
            <h1 className="text-xl">WEDNESDAY</h1>
            <Link
            to="https://mindbodylove.com/schedule"
            className="flex justify-center items-center space-x-2 mt-2"
            >
            <p className="text-lg">6:30AM</p>
            <p className="underline">Vinyasa Yoga (45 Minutes)</p>
            </Link>


            </div>
            <div className="text-center mt-10">
            <h1 className="text-xl">THURSDAY</h1>
            <Link
            to="https://mindbodylove.com/schedule"
            className="flex justify-center items-center space-x-2 mt-2"
            >
            <p className="text-lg">4PM</p>
            <p className="underline">Slow Flow (60 Minutes)</p>
            </Link>

            </div>

        </div>
        <div className="m-20"></div>
        </>
    )
}
